import { render, staticRenderFns } from "./DealStageColor.vue?vue&type=template&id=8f45cbd0&scoped=true"
import script from "./DealStageColor.vue?vue&type=script&lang=js"
export * from "./DealStageColor.vue?vue&type=script&lang=js"
import style0 from "./DealStageColor.vue?vue&type=style&index=0&id=8f45cbd0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f45cbd0",
  null
  
)

export default component.exports